export enum ACCION {
    PRESUPUESTAR = "D",
    FACTURAR = "C"
}

export enum PROCEDENCIA {
    FACTURA = "F",
    DEVENGA = "D"
}
